import Grid from "components/primitives/Grid";
import { styled } from "@mui/material";

export const ColorBlockGrid = styled(Grid)(({ theme }) => ({
  height: theme.spacing(9),
  width: theme.spacing(4),
  marginRight: theme.spacing(3),
}));
